import gql from "graphql-tag";

export const CREATE_CARD_SETUP_INTENT = gql`
  mutation createCardSetupIntent($contactId: ID!, $nameOnCard: String) {
    createCardSetupIntent(contactId: $contactId, nameOnCard: $nameOnCard)
  }
`;
